// extracted by mini-css-extract-plugin
module.exports = {"smsConfirm":"style-module--smsConfirm--2k6KP","newPass":"style-module--newPass--23K05"};